<app-chart-wrapper [title]="'Clients Occupation'" i18n-title="@@client_occupation" (fullscreen)="hideFilters = $event">
    <app-chart-filter filter [form]="clientOccupationForm" [formControls]="clientOccupationFormControls" *ngIf="!hideFilters" (filter)="filterClientOccupation($event)"></app-chart-filter>
    <app-chart-client-table table></app-chart-client-table>
</app-chart-wrapper>
